import { jwtDecode } from "jwt-decode";

export function getUserId(token) {
  if (!token) return null
  const decoded = jwtDecode(token);
  return decoded._id
}